import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ApiService } from '../services/api.service';
import { AccessData } from '../models/access-data.model';
import { Router } from '@angular/router';
import { HttpParams } from '@angular/common/http';
import { Profile } from '../models/profile.model';
import { CreditCard } from '../models/credit-card.model';

const { log } = console;

@Injectable()
export class AuthService {
    accessData = new BehaviorSubject<AccessData>(new AccessData());
    clientName = 'noobaAngularShop';
    clientSecret = 'dfU@tRJ0gJTG2ul41xBObKjZSOGl9jSAXEevE2xd7fKnhcIOJDb9';
    profile = new BehaviorSubject<Profile>(null);

    public localUserData: any;

    constructor(
        private apiService: ApiService,
        private router: Router
    ) {
        this.localUserData = JSON.parse(localStorage.getItem('accessData'));
        if (this.localUserData) {
            this.handleNextAccessData(this.localUserData);
        }
    }

    handleNextAccessData(accessData: AccessData) {
        localStorage.setItem('accessData', JSON.stringify(accessData));
        this.accessData.next(accessData);
    }

    login(credentials): Observable<AccessData> {
        const formData = new HttpParams()
            .set('username', credentials.username)
            .set('password', credentials.password)
            .set('grant_type', 'password');
        return this.apiService.post('/Token', formData, 'form', false)
            .pipe(
                map(
                    data => {
                        this.handleNextAccessData(data);
                        this.getProfile().subscribe(() => {
                            // done
                        });
                        return data;
                    }
                )
            );
    }

    getProfile() {
        return this.apiService.get('/api/Customers', 'json', true)
            .pipe(
                map(
                    (data: Profile) => {
                        this.profile.next(data);
                        return data;
                    }
                )
            );
    }

    getCreditCards() {
        return this.apiService.get('/api/Customers/InnoCardPayment/My', 'json', true)
            .pipe(
                map(
                    (data: Array<CreditCard>) => {
                        return data;
                    }
                )
            );
    }

    saveCreditCard(card: CreditCard) {
        return this.apiService.post('/api/Customers/InnoCardPayment/Create', card, 'json', false).pipe(
            map(
                (data) => {

                    return data;
                }
            )
        );
    }

    deleteCreditCard(cardId) {
        return this.apiService.delete('/api/Customers/InnoCardPayment/' + cardId, {}, 'json', true).pipe(
            map(
                (data) => {

                    return data;
                }
            )
        );
    }

    changePassword(pw) {
        return this.apiService.post('/api/Account/ChangePassword', pw, 'json', false).pipe(
            map(
                (data) => {

                    return data;
                }
            )
        );
    }

    resetPassword(pw) {
        return this.apiService.post('/api/Account/ResetPassword', pw, 'json', false).pipe(
            map(
                (data) => {

                    return data;
                }
            )
        );
    }

    register(user) {
        return this.apiService.post('/api/Account/Register', user, 'json', false).pipe(
            map(
                (data: AccessData) => {
                    log('Create User Account Response: ' + JSON.stringify(data));
                    this.handleNextAccessData(data);

                    return data;
                }
            )
        );
    }

    getRefreshToken() {
        // tslint:disable-next-line:max-line-length
        const refreshToken = localStorage.getItem('accessData') ? JSON.parse(localStorage.getItem('accessData')).refresh_token : 'No refreshToken';
        const user = {
            grant_type: 'refresh_token',
            refresh_token: refreshToken,
            client_id: this.clientName,
            client_secret: this.clientSecret
        };
        return this.apiService.post('/token', user, 'json', false).pipe(
            map(
                (data) => {
                    log('RefreshToken Response: ' + JSON.stringify(data));
                    this.handleNextAccessData(data);

                    return data;
                }
            )
        );
    }

    forgotPasswordRequest(credentials) {
        return this.apiService.post('/api/Account/ForgotPassword', credentials, 'json', false).pipe(
            map(
                data => {
                    return data;
                }
            )
        );
    }

    forgotPasswordReset(credentials) {
        return this.apiService.post('/api/Account/ResetPassword', credentials, 'form', false).pipe(
            map(
                data => {
                    return data;
                }
            )
        );
    }


    logout() {
        this.accessData.next(new AccessData());
        localStorage.removeItem('accessData');
    }

    makeGuid() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }

    saveProfile(profile) {
        return this.apiService.put('/api/Customers', profile, 'json', true).pipe(
            map(
                (data: Profile) => {

                    return data;
                }
            ),
            catchError(
                (error) => {
                    return error;
                }
            )
        );
    }

}
